/**
 * `navigator.onLine`, or null when `navigator` is unavailable (SSR).
 * Attached to error/failure analytics to distinguish offline drops.
 */
export const isOnline = (): boolean | null =>
  typeof navigator !== 'undefined' ? navigator.onLine : null;
